import { apiHost } from '../../../config';
import { put } from '../../requests';
import Municipality from '../../../types/Municipality';

export default async function updateMunicipality(
  id: number,
  municipality: Partial<Omit<Municipality, 'id'>>,
) {
  return put(`${apiHost}/api/admin/municipalities/${id}`, municipality);
}
